<section [ngClass]="cardClass">
  <header [ngClass]="headerClass">
    <div class="flex items-start gap-3">
      @if (showStep) {
        <span [ngClass]="stepClass">
          @if (!isStepIcon) {
            {{ stepLabel }}
          } @else {
            <app-icon-reusable
              [icon]="stepIcon!"
              [size]="18"
              class="flex justify-center text-indigo600"
              [useCurrentColor]="true"
            ></app-icon-reusable>
          }
        </span>
      }
      <div>
        <h2 [ngClass]="headingClass">{{ heading }}</h2>
        @if (subheading) {
          <p [ngClass]="subheadingClass">{{ subheading }}</p>
        }
      </div>
    </div>

    <ng-content select="[form-card-actions]"></ng-content>
  </header>

  <div [ngClass]="contentClass">
    <ng-content></ng-content>
  </div>
</section>
